module.exports = __webpack_public_path__ + "img/vk.5cce65ac.svg";